import { render, staticRenderFns } from "./pdfinstitucion.vue?vue&type=template&id=2275e063"
import script from "./pdfinstitucion.vue?vue&type=script&lang=js"
export * from "./pdfinstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports